import React from 'react';
import { Text, Whitespace } from '../common';
import ProfilePhoto from '../../components/ProfilePhoto/ProfilePhoto';
import Button from '../common/FormComponents/Button';

export default function(props) {
  const { next, photo } = props;

  return (
    <div className={'f f-center-stretch f-rows'}>
      <Whitespace medium />
      <Text h1 textAlign="center" grayDark>Add your picture</Text>
      <Whitespace smaller2 />
      <Text textAlign="center" noclip>
        Hello gorgeous! Let's get a pic of that beautiful mug up for the world
        to see! People are more likely to rent to and from you when you have a
        good profile picture.
      </Text>
      <Whitespace medium />
      <div className="f f-cc f-1">
        <ProfilePhoto small />
      </div>
      <Whitespace medium />
      <Button primary onClick={next} className="m-mxx" action disabled={!photo}>
        Next
      </Button>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components_new/verification/ProfilePhotoVerification.js